


export const projectsData = [
    {
        id: 1,
        projectName: 'The Body Shop- Clone',
        projectDesc: 'Online E-commerce cloned with the help of Html, CSS, javascript with added Cart functionality where data is being passed onto the different page using local storage, created OTP-based login and logout functionality, once the product is ordered successfully it redirects to about us page then to homepage itself.',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/gurdeep7/mybodyshop',
        demo: 'https://gurdeep7.github.io/mybodyshop/html/home',
        image: "https://github.com/gurdeep7/mybodyshop/blob/main/images/homePage.png?raw=true"
    },
    {
        id: 2,
        projectName: 'UpGrad- Clone',
        projectDesc: 'It is a clone of upgrad.com. We used HTML, JavaScript, Tailwind CSS, Mongo DB, and Express JS  in this Project. We implement features like login by OTP method, Token Authorisation, and sending Confirmation email when a user buys a course.',
        tags: ['HTML', 'CSS', 'JavaScript',"Mongo DB", 'Node JS','express JS'],
        code: 'https://github.com/gurdeep7/upgrad',
        demo: 'https://gurdeep7.github.io/upgrad/html/index.html',
        image: "https://github.com/gurdeep7/upgrad/blob/main/images/homePage.png?raw=true"
    },
    {
        id: 3,
        projectName: 'Twitter -clone',
        projectDesc: 'It is a clone of twitter.com. We used HTML, JavaScript, Tailwind CSS, Mongo DB, and Express JS in this Project. We implement features like login, Sign up, Real time chat and posting a tweet.',
        tags: ['HTML', 'CSS', 'JavaScript',"Mongo DB", 'Node JS','express JS',"React JS"],
        code: 'https://github.com/gurdeep7/twitter-frontend',
        demo: 'https://twitter-cloned12.netlify.app/',
        image: "https://raw.githubusercontent.com/gurdeep7/twitter-frontend/main/images/chat.png"
    },
    {
        id: 4,
        projectName: 'Google-Translator(Clone)',
        projectDesc: 'TIt is a clone of Google Translator, I used API for laguage conversion and advance Javascript for voice to text or vice-versa. It Supports 18 languages including Hindi, English, Chinese, Urdu etc.',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/gurdeep7/googleTranslator',
        demo: 'https://keen-payne-9927b6.netlify.app/',
        image: "https://github.com/gurdeep7/googleTranslator/raw/main/Screenshot.png"
    },
   
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/